import { render, staticRenderFns } from "./RadialChartVT.vue?vue&type=template&id=13cb8e34&scoped=true"
import script from "./RadialChartVT.vue?vue&type=script&lang=js"
export * from "./RadialChartVT.vue?vue&type=script&lang=js"
import style0 from "./RadialChartVT.vue?vue&type=style&index=0&id=13cb8e34&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13cb8e34",
  null
  
)

export default component.exports